export const REGISTRATION_FORM_MAIN_NAME = 'reg_form';
export const REGISTRATION_FORM_MAIN_ID = '1';
